<div class="combo-pesquisavel">
    <mat-form-field [ngStyle]="{width: '100%'}">
        <mat-select
                (selectionChange)="onMudancaSelecao($event)"
                [disabled]="desabilitado || configuracaoMesclada.desabilitado"
                [multiple]="configuracaoMesclada.multiplo"
                [placeholder]="configuracaoMesclada.exibirPlaceholder ? configuracaoMesclada.placeholder : ''"
                [value]="valor"
                [panelClass]="configuracaoMesclada.panelClass || ''"
                class="combopesquisavel">

            <!-- Campo de pesquisa com ngx-mat-select-search -->
            <mat-option *ngIf="configuracaoMesclada.habilitarPesquisa">
                <ngx-mat-select-search
                        ngModel #searchInput
                        [placeholderLabel]="configuracaoMesclada.placeholderPesquisa"
                        [noEntriesFoundLabel]="'Nenhum resultado encontrado'"
                        [clearSearchInput]="true"
                        (input)="onMudancaPesquisa(searchInput.value)"
                        [ngModelOptions]="{standalone: true}">
                    <mat-icon fontIcon="clear" ngxMatSelectSearchClear></mat-icon>
                </ngx-mat-select-search>
            </mat-option>

            <!-- Opção vazia -->
            <mat-option
                    *ngIf="configuracaoMesclada.mostrarOpcaoVazia"
                    [value]="null">
                {{ configuracaoMesclada.textoOpcaoVazia }}
            </mat-option>

            <!-- Opções filtradas -->
            <mat-option
                    *ngFor="let opcao of opcoesFilter | async"
                    [disabled]="opcao.ativo === false"
                    [value]="obterValor(opcao)">
                {{ obterValorExibicao(opcao) }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
